import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { Avatar } from 'src/UIComponents';
import Navigation from './Navigation';

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

export const StyledNavigation = styled(Navigation)`
  flex-grow: 1;
  margin-right: ${({ theme }) => theme.spacing.md};

  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    margin-right: ${({ theme }) => theme.spacing.sm};
  }
`;

export const GradientBackground = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  background-size: cover;
  background-position: center;
  color: white;
  background: linear-gradient(135deg, rgb(0, 48, 73) 0%, rgb(9, 12, 35) 100%);
  padding-bottom: ${({ theme }) => theme.spacing.md};
  border-bottom: 1px ${({ theme }) => theme.colors.N40} solid;

  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    padding: ${({ theme }) => theme.spacing.sm} 0;
  }
`;

export const Content = styled.div`
  flex-grow: 1;
  overflow-y: auto;

  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    .no-fullscreen {
      padding-left: ${({ theme }) => theme.spacing.md};
      padding-right: ${({ theme }) => theme.spacing.md};
    }
  }
`;

export const FullScreen = styled.div`
  width: 100vw;
  height: 100%;
`;

export const UserAvatar = styled(Avatar)`
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    margin-right: ${({ theme }) => theme.spacing.sm};
  }
`;

export const ProfileLink = styled(NavLink)`
  text-decoration: none;
  display: contents;

  ${UserAvatar} {
    opacity: 0.8;
  }

  &:hover {
    ${UserAvatar} {
      opacity: 1;
    }
  }
`;

export const ExpandBar = styled.div`
  margin-top: ${({ theme }) => theme.spacing.md};

  & > * {
    width: 100%;
  }

  input {
    opacity: 0.9;

    &:hover,
    &:focus {
      opacity: 1;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    padding: 0 ${({ theme }) => theme.spacing.md};
  }
`;

export const Bar = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Actions = styled.div`
  align-self: stretch; // Enlarge click area

  & > svg {
    height: 100%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    position: fixed;
    bottom: 1em;
    right: 0.6em;
  }
`;

export const SvgButton = styled.button`
  background-color: transparent;
  border: 0;
  padding: 0 ${({ theme }) => theme.spacing.md};
  height: 100%;
  line-height: 1em;

  transition: transform 200ms;

  &:hover {
    transform: scale(1.2);
  }

  svg {
    stroke: ${({ theme }) => theme.colors.N50};
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    background: ${({ theme }) => theme.colors.primary};
    width: 3em;
    height: 3em;
    padding: 0;
    border: 1px solid ${({ theme }) => theme.colors.N50};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
